import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BusinessPartnerEmployeeModel from '../../../models/BusinessPartnerEmployeeModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddEmployeePopup from '../Popups/BusinessPartner_popup_AddEmployee';

const BusinessPartner_tab_Employees: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<BusinessPartnerEmployeeModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<BusinessPartnerEmployeeModel[]>('api/v1/BusinessPartnerEmployees/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: BusinessPartnerEmployeeModel) {
        DataService.delete('api/v1/BusinessPartnerEmployees/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'Id', visible: false },
        { title: 'Employee', dataProp: 'employee.user', dataType: 'user', sort: 'asc' },
        { title: 'Role', dataProp: 'functionalRole.name' },
    ];

    const { isAuthorizedFor } = useAuth();
    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerEmployees'
                colInfos={colInfos}
                tableData={data}
            />
            {showPopup && <AddEmployeePopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}

        </>
    );
}
export default BusinessPartner_tab_Employees;